<div
  *ngIf="!isTablet && !isMobile"
  ngbDropdown
  class="my-account-links-container d-flex h-100"
  placement="bottom-right"
>
  <button class="btn btn-link p-0 my-auto border-0" id="myAccountDropdown" ngbDropdownToggle>
    <mat-icon class="material-icons-sharp light">menu</mat-icon>
    <div
      ngbDropdownMenu
      class="dropdown-menu dropdown-menu-right rounded-0 border-0 js-header-menu"
      aria-labelledby="myAccountDropdown"
    >
      <ng-container *ngFor="let item of myAccountNavNodeOverride?.children || myAccountNavNode.children">
        <button
          ngbDropdownItem
          class="d-flex align-items-center rounded-0 dropdown-customStyling"
          (click)="onClick(item.url, item.styleClasses)"
          *ngIf="!!item.url"
          [class.hidden]="item.url === '/dealer-selection' && !asmEnabled"
        >
          {{ item.title }}
        </button>
      </ng-container>
    </div>
  </button>
</div>

<div
  *ngIf="isTablet"
  [class.show]="showMyAccountDropdown"
  class="my-account-links-container-tablet dropdown d-flex h-100"
>
  <button
    class="btn btn-link dropdown-toggle p-0 my-auto border-0"
    [attr.aria-expanded]="showMyAccountDropdown"
    (click)="onClickMyAccountDropdown($event)"
    (clickOutside)="closeMyAccountDropdown()"
  >
    <mat-icon data-toggle="dropdown" class="material-icons-sharp light">menu</mat-icon>
    <mat-nav-list class="dropdown-menu dropdown-menu-edge rounded-0 border-0" [class.d-none]="!showMyAccountDropdown">
      <!-- My Account Menu -->
      <div *ngFor="let myAccountNav of myAccountLinksOverride || myAccountLinks">
        <mat-list-item
          class="hamburger-menu-icon"
          (click)="onClickSubMenu($event, 0)"
          *ngIf="myAccountNav.children"
          disableRipple
        >
          <mat-icon class="material-icons-sharp light">menu</mat-icon>
          <mat-icon class="material-icons-sharp light md-16 ml-auto menu-button" [class.rotated]="showSubSubMenu[0]"
            >expand_more</mat-icon
          >
        </mat-list-item>
        <div
          class="submenu-container"
          [class.expanded]="showSubSubMenu[0]"
          [class.d-none]="!showSubSubMenu[0]"
          *ngIf="myAccountNav.children && showSubSubMenu[0]"
        >
          <div class="subsubmenu-container d-xl-none" *ngFor="let myAccountNavChild of myAccountNav.children">
            <mat-list-item
              (click)="onClick(myAccountNavChild.url, myAccountNavChild.styleClasses)"
              disableRipple
              *ngIf="myAccountNavChild.url"
              [class.hidden]="myAccountNavChild.url === '/dealer-selection' && !asmEnabled"
            >
              <span class="submenu">{{ myAccountNavChild.title | titlecase }}</span>
            </mat-list-item>
          </div>
        </div>
      </div>
      <!-- Header Links -->
      <div *ngFor="let headerLinkComponent of headerLinksMobileNavEntries">
        <mat-list-item class="header-links-class" (click)="onClick(headerLinkComponent.url)" disableRipple>
          <span class="submenu">{{ headerLinkComponent.linkName | titlecase }}</span>
        </mat-list-item>
      </div>
      <!-- Languages -->
      <div *ngFor="let languageNav of languageMobileNavNode" [class.no-flags]="!(isLanguageFlagIconEnabled$ | async)">
        <mat-list-item
          class="language-class"
          (click)="onClickSubMenu($event, 1)"
          *ngIf="languageNav.children"
          disableRipple
        >
          <span
            *ngIf="languageNav.title === 'Languages' && activeLanguageCountryIsocode"
            class="flag:{{
              (isCountryFlagInsteadEnabled$ | async)
                ? (activeCountry$ | async | uppercase)
                : activeLanguageCountryIsocode
            }} mr-2"
          ></span>
          <span *ngIf="languageNav.title === 'Languages'" class="submenu">{{ activeLanguageName | titlecase }}</span>
          <mat-icon class="material-icons-sharp light md-16 ml-auto menu-button" [class.rotated]="showSubSubMenu[1]"
            >expand_more</mat-icon
          >
        </mat-list-item>
        <div
          class="submenu-container"
          [class.expanded]="showSubSubMenu[1]"
          [class.d-none]="!showSubSubMenu[1]"
          *ngIf="languageNav.children && showSubSubMenu[1]"
        >
          <div class="subsubmenu-container d-xl-none" *ngFor="let languageNavChild of languageNav.children">
            <mat-list-item (click)="onClick(languageNavChild.url)" disableRipple *ngIf="languageNavChild.url">
              <span class="submenu">{{ languageNavChild.title | titlecase }}</span>
            </mat-list-item>
            <mat-list-item
              (click)="setShimanoActiveLanguage(languageNavChild.isocode)"
              disableRipple
              *ngIf="languageNavChild.isocode"
            >
              <span
                class="flag:{{
                  (isCountryFlagInsteadEnabled$ | async)
                    ? (activeCountry$ | async | uppercase)
                    : languageNavChild.country.isocode
                }} mr-1"
              ></span>
              <span class="subsubmenu" [class.selected]="activeLanguageIsocode === languageNavChild.isocode">{{
                languageNavChild.name | titlecase
              }}</span>
              <!-- test -->
              <mat-icon
                svgIcon="check"
                class="check-icon ml-auto md-12 dark"
                *ngIf="activeLanguageIsocode === languageNavChild.isocode"
              ></mat-icon>
            </mat-list-item>
          </div>
        </div>
      </div>
    </mat-nav-list>
  </button>
</div>

<div *ngIf="isMobile" class="my-account-links-container-mobile d-flex h-100">
  <button class="btn btn-link p-0 my-auto border-0" (click)="onShowMyAccountMobileDialogRef()">
    <mat-icon class="material-icons-sharp light">menu</mat-icon>
  </button>
</div>
